import { Component, useContext, useEffect, useState } from "react";
import {
  AppBar,
  Drawer,
  Grid2,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  Box
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"; // Appointments
import PeopleIcon from "@mui/icons-material/People"; // Patients
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import BusinessIcon from "@mui/icons-material/Business"; // Facility
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import { Link, useLocation } from "react-router-dom";
import { Links, MainMenu } from "./Utility/Constants";
import AuthContext from "./Context/AuthProvider";
import { AccountCircle, FormatListBulletedOutlined } from "@mui/icons-material";
import { getDisplayValue } from "./Utility/Utility";
import { clearAuth } from "./Utility/AuthManager";

function MenuHeader1() {
  const [selectedMenuName, setSelectedMenuName] = useState(MainMenu.myWorklist);
  const auth = useContext(AuthContext);
  const {setAuth} = useContext(AuthContext);

  const [showUserMenu, setShowUserMenu] = useState();
  const location = useLocation();
  const path = location?.pathname;
  const mainMenuBorderWidth = 3;
  useEffect(
    () => {
      switch (path) {
        case Links.todayQueue:
        case Links.allAppointments:
        case Links.newAppointment:
          setSelectedMenuName(MainMenu.appointments);
          break;

        
        case Links.patientAnalytics:
        case Links.schedulingAnalytics:
          setSelectedMenuName(MainMenu.dashboard);
          break;

        case Links.root:
        case Links.myWorklist:
          setSelectedMenuName(MainMenu.myWorklist);
          break;

        case Links.facilityBasicDetails:
        case Links.facilityService:
        case Links.facilityStaff:
          setSelectedMenuName(MainMenu.facilitySettings);
          break;
        case Links.mySettings:
        case Links.profileSettings:
        case Links.availabilitySettings:
        case Links.prescriptionSettings:
          setSelectedMenuName(MainMenu.mySettings);
          break;

        case Links.billing:
          setSelectedMenuName(MainMenu.billing);
          break;

        case Links.patient:
          setSelectedMenuName(MainMenu.patients);
          break;

        default:
          break;
      }
    },
    [path]
  );

  return (
    <div>
   
      <AppBar color="primary" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
  <Grid2 container size={12}>
    {/* Title Section */}
    <Grid2 size={4} sx={{ alignContent: "center", paddingLeft: "10px" }}>
      <Typography
        variant="h5"
        component="div"
        sx={{
          flexGrow: 1,
          fontSize: {
            xs: "0.75rem", // Phones
            sm: "0.875rem", // Tablets
            md: "1rem", // Desktops
            lg: "1.125rem", // Large Desktops
            xl: "1.25rem", // Extra Large Desktops
          },
        }}
      >
        Click Health Pro
      </Typography>
    </Grid2>

    {/* Facility Name Section */}
    <Grid2
      container
      size={4}
      sx={{ alignItems: "center", justifyContent: "center" }}
    >
      {/* {auth?.auth?.selectedFacility?.logo && (
        <img
          src={auth?.auth?.selectedFacility?.logo}
          sx={{
            height: {
              xs: 20, // Phones
              sm: 20, // Tablets
              md: 20, // Desktops
              lg: 20, // Large Desktops
              xl: 20, // Extra Large Desktops
            },
            width: {
              xs: 20, // Phones
              sm: 20, // Tablets
              md: 20, // Desktops
              lg: 20, // Large Desktops
              xl: 20, // Extra Large Desktops
            },
          }}
          alt="logo"
        />
      )} */}
      {auth?.auth?.selectedFacility?.logo && (
  <Box
    component="img"
    src={auth?.auth?.selectedFacility?.logo}
    alt="logo"
    sx={{
     height: {
          xs: 15.5, 
        sm: 17.5, 
        md: 23.5, 
        lg: 25.5, 
        xl: 27.5, 
      },
      width: {
         xs: 15.5, // Phones (16 - 0.5)
        sm: 17.5, // Tablets (18 - 0.5)
        md: 23.5, // Desktops (22.5 + 1)
        lg: 25.5, // Large Desktops (24.5 + 1)
        xl: 27.5, // Extra Large Desktops (26.5 + 1)
      },
      marginRight: {
        xs: 1, // 8px spacing for phones
        sm: 1.5, // 12px spacing for tablets
        md: 2, // 16px spacing for desktops and above
      },
      objectFit: "cover", 
      objectPosition: "center top", 
      borderRadius: "50%", 
     
    }}
  />
)}

      <Typography
        variant="h5"
        sx={{
          fontSize: {
            xs: "0.75rem", // Phones
            sm: "0.875rem", // Tablets
            md: "1rem", // Desktops
            lg: "1.125rem", // Large Desktops
            xl: "1.25rem", // Extra Large Desktops
          },
        }}
      >
        {auth?.auth?.selectedFacility?.name}
      </Typography>
    </Grid2>

    {/* User Welcome Section */}
    <Grid2 size={4}>
      {auth && (
        <Grid2
          container
          sx={{ alignItems: "center", justifyContent: "end" }}
        >
        <Grid2 container sx={{justifyContent:"end"}} size={{xs:9,sm:9,md:10,lg:11,xl:11}}>
          <Typography
          noWrap
            sx={{
              fontSize: {
                xs: "0.75rem", // Phones
                sm: "0.875rem", // Tablets
                md: "1rem", // Desktops
                lg: "1.125rem", // Large Desktops
                xl: "1.25rem", // Extra Large Desktops
              },
            }} 
          >
            Welcome, {auth.auth.userFullName}
          </Typography>
        </Grid2>
        <Grid2 container sx={{justifyContent:"end"}} size={{xs:3,sm:3,md:2,lg:1,xl:1}}>
          <IconButton
            sx={{
        fontSize: { xs: "18px", sm: "24px", md: "30px" }, // Adjust size based on screen
        width: { xs: "32px", sm: "40px", md: "48px" },
        height: { xs: "32px", sm: "40px", md: "48px" },
      }}
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={() => setShowUserMenu(true)}
            color="inherit"
          >
            <AccountCircle fontSize="inherit" />
           
          </IconButton>
          </Grid2>
          <Menu
            id="menu-appbar"
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            open={showUserMenu}
            onClose={() => setShowUserMenu(false)}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem
              onClick={() => {
                clearAuth();
                setAuth();
              }}
            >
              Log Out
            </MenuItem>
          </Menu>
        </Grid2>
      )}
    </Grid2>
  </Grid2>
</AppBar>
      
 <Drawer variant="permanent" anchor="left">
  <List
    sx={{
      paddingTop: {
        xs: "55px", // Smaller padding for phones
        sm: "60px", // Slightly larger padding for tablets
        md: "65px", // Default padding for desktops and larger screens
      },
      paddingX: "0px",
    }}
  >
    {/* Dashboard */}
    {/* <ListItem
      sx={{
        paddingX: "5px",
        paddingY: {
          xs: "0.25rem", // Smaller padding for phones
          sm: "0.5rem", // Slightly larger padding for tablets
          md: "1px", // Default padding for desktops and larger screens
        },
        borderColor: "secondary.main",
        borderStyle: "solid",
        borderRightWidth: selectedMenuName === MainMenu.dashboard ? mainMenuBorderWidth : 0,
        borderLeftWidth: 0,
        borderBottomWidth: 0,
        borderTopWidth: 0,
      }}
    >
      <Tooltip title={getDisplayValue(MainMenu.dashboard)} arrow placement="right">
        <Link to={Links.dashboard}>
          <IconButton
            color={
              selectedMenuName === MainMenu.dashboard ? "secondary" : "default"
            }
            onClick={() => setSelectedMenuName(MainMenu.dashboard)}
          >
            <DashboardRoundedIcon />
          </IconButton>
        </Link>
      </Tooltip>
    </ListItem> */}

    {/* My Worklist */}
    <ListItem
      sx={{
        paddingX: "5px",
        paddingY: {
          xs: "0.25rem", // Smaller padding for phones
          sm: "0.5rem", // Slightly larger padding for tablets
          md: "1px", // Default padding for desktops and larger screens
        },
        borderColor: "secondary.main",
        borderStyle: "solid",
        borderRightWidth: selectedMenuName === MainMenu.myWorklist ? mainMenuBorderWidth : 0,
        borderLeftWidth: 0,
        borderBottomWidth: 0,
        borderTopWidth: 0,
      }}
    >
      <Tooltip title={getDisplayValue(MainMenu.myWorklist)} arrow placement="right">
        <Link to={Links.myWorklist}>
          <IconButton
            color={
              selectedMenuName === MainMenu.myWorklist ? "secondary" : "default"
            }
            onClick={() => setSelectedMenuName(MainMenu.myWorklist)}
          >
            <FormatListBulletedOutlined />
          </IconButton>
        </Link>
      </Tooltip>
    </ListItem>

    {/* Appointments */}
    <ListItem
      sx={{
        paddingX: "5px",
        paddingY: {
          xs: "0.25rem", // Smaller padding for phones
          sm: "0.5rem", // Slightly larger padding for tablets
          md: "1px", // Default padding for desktops and larger screens
        },
        borderColor: "secondary.main",
        borderStyle: "solid",
        borderRightWidth: selectedMenuName === MainMenu.appointments ? mainMenuBorderWidth : 0,
        borderLeftWidth: 0,
        borderBottomWidth: 0,
        borderTopWidth: 0,
      }}
    >
      <Tooltip title={getDisplayValue(MainMenu.visits)} arrow placement="right">
        <Link to={Links.allAppointments}>
          <IconButton
            color={
              selectedMenuName === MainMenu.appointments ? "secondary" : "default"
            }
            onClick={() => setSelectedMenuName(MainMenu.appointments)}
          >
            <CalendarMonthRoundedIcon />
          </IconButton>
        </Link>
      </Tooltip>
    </ListItem>

    {/* Patients */}
    <ListItem
      sx={{
        paddingX: "5px",
        paddingY: {
          xs: "0.25rem", // Smaller padding for phones
          sm: "0.5rem", // Slightly larger padding for tablets
          md: "1px", // Default padding for desktops and larger screens
        },
        borderColor: "secondary.main",
        borderStyle: "solid",
        borderRightWidth: selectedMenuName === MainMenu.patients ? mainMenuBorderWidth : 0,
        borderLeftWidth: 0,
        borderBottomWidth: 0,
        borderTopWidth: 0,
      }}
    >
      <Tooltip title={getDisplayValue(MainMenu.patients)} arrow placement="right">
        <Link to={Links.patient}>
          <IconButton
            color={
              selectedMenuName === MainMenu.patients ? "secondary" : "default"
            }
            onClick={() => setSelectedMenuName(MainMenu.patients)}
          >
            <PeopleIcon />
          </IconButton>
        </Link>
      </Tooltip>
    </ListItem>

    {/* Billing */}
    <ListItem
      sx={{
        paddingX: "5px",
        paddingY: {
          xs: "0.25rem", // Smaller padding for phones
          sm: "0.5rem", // Slightly larger padding for tablets
          md: "1px", // Default padding for desktops and larger screens
        },
        borderColor: "secondary.main",
        borderStyle: "solid",
        borderRightWidth: selectedMenuName === MainMenu.billing ? mainMenuBorderWidth : 0,
        borderLeftWidth: 0,
        borderBottomWidth: 0,
        borderTopWidth: 0,
      }}
    >
      <Tooltip title={getDisplayValue(MainMenu.billing)} arrow placement="right">
        <Link to={Links.billing}>
          <IconButton
            color={
              selectedMenuName === MainMenu.billing ? "secondary" : "default"
            }
            onClick={() => setSelectedMenuName(MainMenu.billing)}
          >
            <AccountBalanceWalletRoundedIcon />
          </IconButton>
        </Link>
      </Tooltip>
    </ListItem>

    {/* Settings */}
    {/* <ListItem
      sx={{
        paddingX: "5px",
        paddingY: {
          xs: "0.25rem", // Smaller padding for phones
          sm: "0.5rem", // Slightly larger padding for tablets
          md: "1px", // Default padding for desktops and larger screens
        },
        borderColor: "secondary.main",
        borderStyle: "solid",
        borderRightWidth: selectedMenuName === MainMenu.mySettings ? mainMenuBorderWidth : 0,
        borderLeftWidth: 0,
        borderBottomWidth: 0,
        borderTopWidth: 0,
      }}
    >
      <Tooltip title={getDisplayValue(MainMenu.mySettings)} arrow placement="right">
        <Link to={Links.mySettings}>
          <IconButton
            color={
              selectedMenuName === MainMenu.mySettings ? "secondary" : "default"
            }
            onClick={() => setSelectedMenuName(MainMenu.mySettings)}
          >
            <ManageAccountsRoundedIcon />
          </IconButton>
        </Link>
      </Tooltip>
    </ListItem> */}

    {/* Facility */}
    <ListItem
      sx={{
        paddingX: "5px",
        paddingY: {
          xs: "0.25rem", // Smaller padding for phones
          sm: "0.5rem", // Slightly larger padding for tablets
          md: "1px", // Default padding for desktops and larger screens
        },
        borderColor: "secondary.main",
        borderStyle: "solid",
        borderRightWidth: selectedMenuName === MainMenu.facilitySettings ? mainMenuBorderWidth : 0,
        borderLeftWidth: 0,
        borderBottomWidth: 0,
        borderTopWidth: 0,
      }}
    >
      <Tooltip title={getDisplayValue(MainMenu.facilitySettings)} arrow placement="right">
        <Link to={Links.facilityBasicDetails}>
          <IconButton
            color={
              selectedMenuName === MainMenu.facilitySettings ? "secondary" : "default"
            }
            onClick={() => setSelectedMenuName(MainMenu.facilitySettings)}
          >
            <BusinessIcon />
          </IconButton>
        </Link>
      </Tooltip>
    </ListItem>
  </List>
</Drawer>





















    </div>
  );
}

export default MenuHeader1;
